import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar003 from "../projects/ESID-24-003/components/sidebar003";
import Sidebar031 from "../projects/ESID-24-031/components/sidebar031";
import Sidebar013 from "../projects/ESID-25-013/components/sidebar013";
import Sidebar006 from "../projects/ESID-25-006/components/sidebar006";
import Sidebar011 from "../projects/ESID-25-011/components/sidebar011";
import WarningStacks from "../projects/shared/components/WarningStacks";
import SettingsModal from "../projects/ESID-24-003/components/settings/SettingsModal";
import SettingsModalGrootbijgaarden from "../projects/ESID-24-031/components/settings/SettingsModal";
import SettingsModalLeadgen from "../projects/ESID-25-013/components/settings/SettingsModal";
import SettingsModalLumen from "../projects/ESID-25-011/components/settings/SettingsModal";
import DailyPlannerModal from "../projects/ESID-24-003/components/dailyplanner/DailyPlannerModal";
import DailyPlannerModalGrootbijgaarden from "../projects/ESID-24-031/components/dailyplanner/DailyPlannerModal";
import DailyPlannerModalLumen from "../projects/ESID-25-011/components/dailyplanner/DailyPlannerModal";
import { Outlet } from 'react-router-dom';
import config from '../config';
import { useProject } from '../context/ProjectContext';

function ProtectedLayout({ alert, setLoading, triggerAlert, settingsTrigger }) {
  const [isPlanningOpen, setIsPlanningOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const location = useLocation();
  const selectedProject = localStorage.getItem('selectedProject');
  
  const isLoginPage = location.pathname === '/signin' || location.pathname === '/signup';
  const isNotAuthorized = location.pathname === '/not-authorized';
  const isProjectSelection = location.pathname === '/project-selection';
  const isNotFound = location.pathname === '*' || location.pathname === '/404' || location.pathname === '/not-found';
  const navigate = useNavigate();

  const renderSidebar = () => {
    if (location.pathname.includes('esid-24-003')) {
      return <Sidebar003
        setIsPlanningOpen={setIsPlanningOpen}
        isPlanningOpen={isPlanningOpen}
        setIsSettingsOpen={setIsSettingsOpen}
        isSettingsOpen={isSettingsOpen}
      />;
    } else if (location.pathname.includes('esid-24-031')) {
      return <Sidebar031
        setIsPlanningOpen={setIsPlanningOpen}
        isPlanningOpen={isPlanningOpen}
        setIsSettingsOpen={setIsSettingsOpen}
        isSettingsOpen={isSettingsOpen}
      />;
    } else if (location.pathname.includes('esid-25-013')) {
      return <Sidebar013
        setIsPlanningOpen={setIsPlanningOpen}
        isPlanningOpen={isPlanningOpen}
        setIsSettingsOpen={setIsSettingsOpen}
        isSettingsOpen={isSettingsOpen}
      />;
    }else if (location.pathname.includes('esid-25-006')) {
      return <Sidebar006
        setIsPlanningOpen={setIsPlanningOpen}
        isPlanningOpen={isPlanningOpen}
        setIsSettingsOpen={setIsSettingsOpen}
        isSettingsOpen={isSettingsOpen}
      />;
    }else if (location.pathname.includes('esid-25-011')) {
      return <Sidebar011
        setIsPlanningOpen={setIsPlanningOpen}
        isPlanningOpen={isPlanningOpen}
        setIsSettingsOpen={setIsSettingsOpen}
        isSettingsOpen={isSettingsOpen}
      />;
    }
    return null;
  };

  const { handleLogout } = useProject();

  const logout = async () => {
    await handleLogout();
    localStorage.removeItem('selectedProject');
    localStorage.removeItem('allowedPages');
    localStorage.removeItem('allowedProjects');
    localStorage.removeItem('all_roles');
    navigate('/signin');
  }
  useEffect(() => {
    const storedVersion = localStorage.getItem('appVersion');

    if (storedVersion && storedVersion?.length > 0 && storedVersion !== config.meta.VERSION) {
      localStorage.setItem('appVersion', config.meta.VERSION);
      //if window.location.pathname is /esid-25-013/dashboard something like that then dont logout
      if(window.location.pathname.includes('013')) {
        return;
      }else{        
        logout();
      }
    } else {
      localStorage.setItem('appVersion', config.meta.VERSION);
    }
  }, [config.meta.VERSION]);
  return (
    <>
      {!isLoginPage && !isNotAuthorized && !isProjectSelection && !isNotFound && renderSidebar()}

      <main className="content">
        {selectedProject === "esid-24-003" && (
          <>
            <SettingsModal
              open={isSettingsOpen}
              onClose={() => setIsSettingsOpen(false)}
              setLoading={setLoading}
              triggerAlert={triggerAlert}
            />
            <DailyPlannerModal
              open={isPlanningOpen}
              onClose={() => setIsPlanningOpen(false)}
              setLoading={setLoading}
              triggerAlert={triggerAlert}
            />
          </>
        )}

        {selectedProject === "esid-24-031" && (
          <>
            <SettingsModalGrootbijgaarden
              open={isSettingsOpen}
              onClose={() => setIsSettingsOpen(false)}
              setLoading={setLoading}
              triggerAlert={triggerAlert}
            />
            <DailyPlannerModalGrootbijgaarden
              open={isPlanningOpen}
              onClose={() => setIsPlanningOpen(false)}
              setLoading={setLoading}
              triggerAlert={triggerAlert}
            />
          </>
        )}
        {selectedProject === "esid-25-013" && (
          <>
            <SettingsModalLeadgen
              open={isSettingsOpen}
              onClose={() => setIsSettingsOpen(false)}
              setLoading={setLoading}
              triggerAlert={triggerAlert}
              settingsTrigger={settingsTrigger}
            />
          </>
        )}
        {selectedProject === "esid-25-011" && (
          <>
            <SettingsModalLumen
              open={isSettingsOpen}
              onClose={() => setIsSettingsOpen(false)}
              setLoading={setLoading}
              triggerAlert={triggerAlert}
              settingsTrigger={settingsTrigger}
            />
               <DailyPlannerModalLumen
              open={isPlanningOpen}
              onClose={() => setIsPlanningOpen(false)}
              setLoading={setLoading}
              triggerAlert={triggerAlert}
            />
          </>
        )}

        <WarningStacks alert={alert} />
        <Outlet />
      </main>
    </>
  );
}

export default ProtectedLayout;